import React, {useEffect, useState} from 'react';
import ConfirmButton from '../common/ConfirmButton';
import {showAlert} from '../../core/dialog';
import './shoppingList.css';

const ShoppingListRepeatDialog = ({
    open,
    sourceList,
    defaultName,
    onClose,
    onConfirm,
}) => {
    const [name, setName] = useState('');

    useEffect(() => {
        if (!open) {
            return;
        }
        setName(defaultName || '');
    }, [open, defaultName]);

    if (!open || !sourceList) {
        return null;
    }

    const handleBackdropClick = (event) => {
        if (event.target === event.currentTarget) {
            onClose();
        }
    };

    const handleConfirm = () => {
        const trimmed = (name || '').trim();
        if (!trimmed) {
            showAlert('Informe o nome da lista.');
            return;
        }
        onConfirm(trimmed);
    };

    return (
        <div
            className="shopping-list-share-dialog-backdrop"
            onClick={handleBackdropClick}
            role="presentation"
        >
            <div
                className="shopping-list-share-dialog shopping-list-repeat-dialog"
                role="dialog"
                aria-labelledby="shopping-list-repeat-dialog-title"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="shopping-list-share-dialog__header">
                    <h2 id="shopping-list-repeat-dialog-title">Repetir lista</h2>
                    <button
                        type="button"
                        className="shopping-list-share-dialog__close"
                        onClick={onClose}
                        aria-label="Fechar"
                    >
                        ×
                    </button>
                </div>
                <p className="shopping-list-share-dialog__subtitle">
                    Cópia de: {sourceList.name}
                </p>
                <div className="shopping-list-repeat-dialog__field">
                    <label htmlFor="shopping-list-repeat-name">Nome da nova lista</label>
                    <input
                        id="shopping-list-repeat-name"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        autoFocus
                        data-test="shopping-list-repeat-name"
                    />
                </div>
                <div className="shopping-list-share-dialog__actions">
                    <ConfirmButton onClick={handleConfirm}/>
                </div>
            </div>
        </div>
    );
};

export default ShoppingListRepeatDialog;
